import React, { useMemo } from 'react';
import FocusTrap from 'focus-trap-react';
import { type VenueWithMenus } from 'components/SingleItem/Details';
import useFeatureFlagsQuery from 'common/Hooks/UseFeatureFlagsQuery';
import { useParams } from 'react-router-dom';
import { SingleMenuHours } from 'components/OperatingHours/SingleMenuHours';
import MenuHoursAndDates from 'components/OperatingHours/MenuHoursAndDates';

const OPERATING_HOURS_FEATURE_FLAG = 'operatingHoursEnabled';
interface Props {
  currentVenue?: VenueWithMenus | undefined;
}

const OperatingHoursPanel: React.FC<Props> = ({ currentVenue }) => {
  const [data, loading, error] = useFeatureFlagsQuery([OPERATING_HOURS_FEATURE_FLAG]);
  const { menuId, doshiiMenuEncoded } = useParams();

  const isOperatingHoursFeatureEnabled = useMemo(() => {
    if (loading || error || !data) {
      return false;
    }
    const operatingHoursFeatureFlag = data[OPERATING_HOURS_FEATURE_FLAG];
    return !!operatingHoursFeatureFlag?.isEnabled;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);
  return (
    <div>
      {isOperatingHoursFeatureEnabled && (
        <FocusTrap
          active
          focusTrapOptions={{
            escapeDeactivates: false,
            clickOutsideDeactivates: true
          }}
        >
          {menuId ? (
            <SingleMenuHours
              currentVenue={currentVenue}
              menuId={menuId}
              doshiiMenu={doshiiMenuEncoded ? decodeURIComponent(doshiiMenuEncoded) : undefined}
            />
          ) : (
            <MenuHoursAndDates currentVenue={currentVenue} />
          )}
        </FocusTrap>
      )}
    </div>
  );
};

export default OperatingHoursPanel;
